// Megamenu "current page" highlighting.
//
// The whole site header (templates/_components/global/header.twig) is wrapped in
// one `{% cache globally %}` block shared by every non-home page, so the megamenu
// markup is identical on every page and can't carry a server-rendered active
// state — whatever page built the cache would freeze its highlights everywhere.
// Instead every megamenu link renders plain and we mark the current one here,
// per page load. Mirrors Verbb Navigation's matching: exact URL, or an ancestor
// path (`/foo` is active while on `/foo/bar`).

function normalisePath(path) {
  try {
    path = decodeURIComponent(path);
  } catch (e) {
    // malformed %-escape — use it as-is
  }
  path = path.toLowerCase().replace(/\/+$/, "");
  return path === "" ? "/" : path;
}

function markCurrentNav() {
  const current = normalisePath(window.location.pathname);

  document
    .querySelectorAll(".megamenu-panel a[href]")
    .forEach((link) => {
      // Skip external / new-tab links and non-navigational hrefs.
      if (link.target === "_blank" || link.origin !== window.location.origin) {
        return;
      }

      const linkPath = normalisePath(link.pathname);
      if (linkPath === "/") return;

      const isCurrent =
        linkPath === current || current.startsWith(linkPath + "/");

      if (isCurrent) {
        link.classList.add("is-current");
      }
    });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", markCurrentNav);
} else {
  markCurrentNav();
}
